// external imports
import { Modal, ModalBody, ModalHeader } from "reactstrap";

import { useState } from "react";

// our imports
import useUserContext from "Hooks/useUserContext";
import { format } from "date-fns";

interface IProps {
    displayComponent: any;
    showReadMessages?: boolean;
}

export default function SystemStatusMessages({
    displayComponent,
    showReadMessages,
}: IProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [userContext] = useUserContext();

    const messages = userContext.statusMessages;

    if (!messages?.length) {
        return null;
    }

    function hasUnreads() {
        const readMessageTimestamps = localStorage.getItem(
            "readStatusMessageTimestamps"
        );
        if (!readMessageTimestamps && messages.length) {
            return true;
        }
        const readTimestamps = readMessageTimestamps
            ? JSON.parse(readMessageTimestamps)
            : [];

        return messages.some(
            (message) => !readTimestamps.includes(message.Issued_at)
        );
    }

    const toggleModal = () => setIsModalOpen((prev) => !prev);

    const handleModalIconClick = () => {
        setIsModalOpen(true);
        saveReadMessageTimestamps();
    };

    function saveReadMessageTimestamps() {
        const newReadTimestamps = messages.map((message) => message.Issued_at);

        localStorage.setItem(
            "readStatusMessageTimestamps",
            JSON.stringify(newReadTimestamps)
        );
    }

    const shouldRenderDisplayContent = showReadMessages || hasUnreads();

    const displayComponentProps = {
        openMessagesModal: handleModalIconClick,
    };

    return (
        <>
            {shouldRenderDisplayContent &&
                displayComponent(displayComponentProps)}

            {/* Status messages - only shown if there is one */}
            <Modal isOpen={isModalOpen} toggle={toggleModal} size="lg">
                <ModalHeader toggle={toggleModal}>System Status</ModalHeader>
                <ModalBody>
                    {messages.length > 0 &&
                        messages.map((message: IStatusMessage) => {
                            return (
                                <div
                                    key={message.Id}
                                    className={`alert alert-${message.Status_type}`}
                                    style={{ padding: "2rem" }}
                                >
                                    <small>
                                        {format(
                                            new Date(message.Issued_at),
                                            "M/d/yyyy h:mm a"
                                        )}
                                    </small>
                                    <br />
                                    <div
                                        // biome-ignore lint/security/noDangerouslySetInnerHtml: Only comes from Calance admins, so no XSS vulnerability
                                        dangerouslySetInnerHTML={{
                                            __html: message.Status_message,
                                        }}
                                    />
                                </div>
                            );
                        })}
                </ModalBody>
            </Modal>
        </>
    );
}
